import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
    container: {
        marginLeft: 'auto',
        marginTop: '20px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px'
    },
    imagesComponentContainer: {
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
        marginTop: '20px'
    },
    imageContainer: {
        display: 'flex',
        position: 'relative',
        width: '70px',
        height: '40px',

        '&:hover .show-icon': {
            display: 'block'
        }
    },
    iconStyles: {
        position: 'absolute',
        right: '1px',
        top: '1px',
        cursor: 'pointer',
        color: 'red',
        display: 'none',
        ' .show-icon': {
            display: 'none'
        }
    },
    imageWrapper: {
        display: 'flex',
        width: '70px',
        height: '40px'
    },
    imageStyles: {
        width: '100%',
        cursor: 'pointer',
        objectFit: 'cover'
    },
    modalImageStyles: {
        width: '100%'
    },
    avatarContainer: {
        position: 'relative',
        width: '120px',
        height: '120px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.borderRadius50,
        border: theme.border
    },
    iconStyles2: {
        cursor: 'pointer',
        color: theme.primary,
        zIndex: 9999
    },
    buttonsWrapper: {
        width: '50%',
        marginLeft: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        marginBottom: '15px'
    }
}))
